import React from "react";
import "./ReleaseNote.css";

import releaseNotes from "../../../../constants/releases.json";
import { useTranslation } from "react-i18next";
 



export default function ReleaseNote() {
        const { t } = useTranslation();
  return (
    <div className="release-note">
      <div className="release-header">
        <p>{t("release_note_description")}</p>
      </div>

      <div className="release-list">
        {releaseNotes.releases.map((release) => (
          <div className="release-card" key={release.version}>
            <div className="release-top">
              <div>
                <h3>{release.version}</h3>
                <span>{release.date}</span>
              </div>
            </div>

            <ul>
              {release.changes.map((change) => (
                <li key={change}>{change}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}